<template>
  <div class="home" v-loading="loading">
    <div class="page-wrapper">
      <!-- 第一屏 -->
      <section class="page-slide slide-one">
        <div class="page">
          <h3>鼎锐联（上海）科技有限公司</h3>
          <p></p>
        </div>
        <!-- <p class="slogan">创新为本 客户至上</p> -->
        <p class="slogan">务实●创新●融合●卓越</p>
      </section>

      <!-- 第二屏 -->
      <section class="page-slide slide-two">
        <div class="page">
          <h3>经典案例</h3>
          <p>Suecessful Cases</p>
        </div>

        <ul class="case-item">
          <li
            v-for="(item,index) in caseList"
            :key="index"
            v-lazy:background-image="getImageUrl(item.Img)"
          >
            <router-link
              class="text-decoration"
              :to="{ name: 'casedetails', params: { id: item.Id }}"
            >
              <div class="case-item-hover">
                <p class="hover-title">{{ item.Title }}</p>
                <div class="bottom"></div>
                <div class="more">
                  <span>MORE</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </section>

      <!-- 第三屏 -->
      <section class="page-slide slide-three">
        <div class="page">
          <h3>最新资讯</h3>
          <p>Latest News</p>
        </div>

        <div class="news-content">
          <div
            class="news-content-item"
            v-for="(news,i) in newsList"
            :key="i"
          >
            <div :style="'order:' + (i % 2 === 0 ? 1 : 3)">
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: news.Id }}"
              >
                <div
                  class="item-img"
                  v-lazy:background-image="getImageUrl(news.Img)"
                ></div>
              </router-link>
            </div>

            <div style="order:2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>

            <div
              class="item-content"
              :style="'order:' + (i % 2 === 0 ? 3 : 1)"
            >
              <h3>{{ news.Title }}</h3>
              <p>{{ plainText(news.Content) }}</p>
              <span>{{ news.CreateTime }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- 第四屏 -->
      <section class="page-slide slide-four">
        <div class="news">
          <div style="height: 10rem"></div>

          <div class="news-section" v-loading="loading">
            <div class="news-section-content">
              <div class="content-nav">
                <div
                  class="content-nav-btn"
                  :class="{ 'content-nav-active': newstype === 1 }"
                  @click="newstype = 1"
                >
                  公司新闻
                </div>
                <div
                  class="content-nav-btn"
                  :class="{ 'content-nav-active': newstype === 2 }"
                  @click="newstype = 2"
                >
                  行业动态
                </div>
              </div>

              <div class="content-nav-item">
                <div
                  class="item-list"
                  v-for="(item,index) in theNewsList"
                  :key="index"
                >
                  <div
                    class="item-img"
                    v-lazy:background-image="getImageUrl(item.Img)"
                  ></div>

                  <p class="item-list-title">{{ item.Title }}</p>
                  <p class="item-list-content">{{ plainText(item.Content) }}</p>

                  <div class="item-list-more">
                    <router-link
                      class="text-decoration"
                      :to="{ name: 'newsdetails', params: { id: item.Id || item.id }}"
                    >
                      <img src="../assets/img/sanjiao.png" />
                      <span>more</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import builtInMock from "@/mock/home.json";
import builtInNews from "@/mock/news.json";
import { toPlainText } from "@/utils/newsContent";

export default {
  name: "Home",

  data() {
    return {
      loading: true,
      caseList: [],
      newsList: [],
      theNewsList: [],
      newstype: 1
    };
  },

  watch: {
    newstype() {
      this.loadNews();
    }
  },

  mounted() {
    this.loadHome();
    this.loadNews();
  },

  methods: {
    plainText: toPlainText,

    loadHome() {
      this.caseList = builtInMock.Cases || [];
      this.newsList = builtInMock.News || [];
      this.loading = false;
    },

    loadNews() {
      this.theNewsList = builtInNews.filter(
        item => String(item.Type) === String(this.newstype)
      );
    },

    getImageUrl(imgPath) {
      return require(`@/assets/${imgPath}`);
    }
  }
};
</script>

<style lang="scss" scoped>
/* ===== 核心布局 ===== */

.page-wrapper {
  width: 100%;
}

.page-slide {
  // height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* ===== 原有样式（基本未动） ===== */

.page {
  text-align: center;
  height: 100px;

  h3,
  p {
    font-size: 40px;
    color: #fff;
  }
}

.slogan {
  text-align: center;
  // font-size: 50px;
  
  margin-top: 20px;
  font-size: 35px;
  color: #fff;
}

/* 背景 */
.slide-one {
  height: calc(100vh - 60px);
  background: url(../assets/img/home_top.jpg) center/cover no-repeat;
}
.slide-two {
  min-height: calc(100vh);
  background: url(../assets/img/home_do.jpg) center/cover no-repeat;
}
.slide-three {
  min-height: calc(100vh);
  background: url(../assets/img/home_anli.jpg) center/cover no-repeat;
}
.slide-four {
  min-height: calc(100vh - 60px);
  background: url(../assets/img/home_do.jpg) center/cover no-repeat;
}

/* ===== 以下保持你原样式 ===== */

//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}

/* 其余 news / footer / item-list 样式
   👉 你可以直接保留你原来的，一行不用动 */


.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      // width: 360px;
      width: 390px;
      height: 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 15px;
        line-height: 22px; /* 每行高度，保证4行总高度约88px */
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}



.news {
  width: 100%;
  height: 100%;
  // background-color: #14679f;
  // background-color: #2b6fa8;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid red;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}

</style>
